import axios from 'axios';

const apiUrl =
    process.env.REACT_APP_NODE_ENV === 'production'
        ? process.env.REACT_APP_API_URL
        : 'http://localhost:8000';
// const auth_token = localStorage.getItem('token');
// const apiUrl = "http://localhost:8000"
const auth_token = localStorage.getItem('token');

const authServices = {
    uploadImage(data) {
        return axios.post(apiUrl + `/api/aws/images/upload`, data, {
            headers: {
                Authorization: "Bearer " + localStorage.getItem("admin_token"),
            },
        });
    },
    createPost(data) {
        return axios.post(apiUrl + `/api/posts`, data);
    },
    getPosts() {
        return axios.get(apiUrl + `/api/posts`, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token")
            },
        });
    },
    getPost(id) {
        return axios.get(apiUrl + `/api/posts/${id}`, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token"),
            },
        });
    },
    editPost(data) {
        return axios.put(apiUrl + `/api/posts/${data.id}`, data.changes, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token"),
            },
        });
    },
    deletePost(id) {
        return axios.delete(apiUrl + `/api/posts/${id}`, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token"),
            },
        });
    },



    createUpdate(data) {
        return axios.post(apiUrl + `/api/updates`, data);
    },
    getUpdates() {
        return axios.get(apiUrl + `/api/updates`, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token")
            },
        });
    },
    getUpdate(id) {
        return axios.get(apiUrl + `/api/updates/${id}`, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token"),
            },
        });
    },
    editUpdate(data) {
        return axios.put(apiUrl + `/api/updates/${data.id}`, data.changes, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token"),
            },
        });
    },
    deleteUpdate(id) {
        return axios.delete(apiUrl + `/api/updates/${id}`, {
            headers: {
                Authorization: "Bearer" + localStorage.getItem("admin_token"),
            },
        });
    },
};
export default authServices;
